import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Banner from './Banner.jsx'

const AlertBanner = ({
  sticky = false,
  displayTime = 8000,
  lastLogin,
  status,
  title,
  text,
}) => {
  const [display, setDisplay] = useState(Boolean(title || text))
  const [closeForSession, setCloseForSession] = useState(false)

  const setLastLoginSession = useCallback(() => {
    sessionStorage.setItem('CLOSE-LASTLOGIN', JSON.stringify(true))
  }, [])

  const closeClicked = useCallback(() => {
    setDisplay(false)

    if (lastLogin) {
      setLastLoginSession()
      setCloseForSession(true)
    }
  }, [lastLogin, setLastLoginSession])

  useEffect(() => {
    let timeoutId
    if (!sticky) {
      timeoutId = setTimeout(() => {
        closeClicked()
      }, displayTime)
    }

    if (JSON.parse(sessionStorage.getItem('CLOSE-LASTLOGIN'))) {
      setCloseForSession(true)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [sticky, displayTime, closeClicked])

  return display && (!lastLogin || (lastLogin && !closeForSession)) ? (
    <div>
      <Banner
        status={status}
        title={title}
        text={text}
        closeClicked={closeClicked}
      />
    </div>
  ) : null
}

AlertBanner.propTypes = {
  sticky: PropTypes.bool,
  displayTime: PropTypes.number,
  lastLogin: PropTypes.bool,
  status: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
}

export default AlertBanner
